import React from 'react';

import Modal from 'react-bootstrap/Modal';

import Analytics from '../Analytics/index.jsx';
import ArticleMetadata from '../ArticleMetadata/index.jsx';
import ArticleReaction from '../ArticleReaction/index.jsx';
import CMSContent from '../CMSContent/index.jsx';
import LockScreen from '../LockScreen/index.jsx';
import ResponsiveEmbed from '../ResponsiveEmbed/index.jsx';
import Spinner from '../Spinner/index.jsx';

class ArticleContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: true,
    };

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  render() {
    var result = <React.Fragment />;
    var article = this.props.article;

    if (article) {
      var embed = article.embed;
      if (embed) {
        embed = (
          <div className="mb-3">
            <Analytics.VideoEmbeds eventProperties={article.analytics}>
              <ResponsiveEmbed embed={embed} />
            </Analytics.VideoEmbeds>
          </div>
        );
      }
    }

    if (this.props.showContent) {
      var content;
      var header;
      var reactions;

      if (this.props.isBusy || this.props.article === null) {
        content = (
          <div className="cs-daily-posts-article__modal-loader">
            <Spinner />
          </div>
        );
      } else {
        var articleContent;
        var articleComment;
        if (this.props.article.reactions) {
          reactions = (
            <div className="cs-daily-posts-article__reactions">
              <ArticleReaction
                onReactionUpdate={this.props.onReactionUpdate}
                article={this.props.article}
              />
            </div>
          );
        }

        if (!this.props.article.locked) {
          articleContent = (
            <React.Fragment>
              <div className="mb-4">
                <CMSContent
                  content={'<h2>' + this.props.article.title + '</h2>'}
                />
              </div>
              <div className="cs-daily-posts-article__content">
                <Analytics.All eventProperties={article.analytics}>
                  <CMSContent content={this.props.article.content} />
                </Analytics.All>
              </div>
            </React.Fragment>
          );
          articleComment = (
            <div className="mb-4 cs-comments">
              <CMSContent content={this.props.article.comments} />
            </div>
          );
        } else {
          articleContent = <LockScreen {...this.props.article} />;
        }

        header = <ArticleMetadata container="modal" article={this.props.article} />;
        content = (
          <div className="cs-daily-posts-article cs-daily-posts-article--modal">
            {embed}
            {articleContent}
            {reactions}
            {articleComment}
          </div>
        );
      }

      result = (
        <Modal
          show={this.state.showModal}
          centered
          size="xl"
          onExited={this.props.onClose}
          onHide={this.closeModal}
        >
          <Modal.Header closeButton>{header}</Modal.Header>
          <Modal.Body>{content}</Modal.Body>
        </Modal>
      );
    }

    return result;
  }
}

export default ArticleContent;
